import { z } from 'zod';

export const ApiTagRequestTypeSchema = z.object({
  id: z.string(),
  common_id: z.string(),
  name: z.string(),
  description: z.string(),
  category: z.string(),
});

export type ApiTagRequestType = z.infer<typeof ApiTagRequestTypeSchema>;
